import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import {
  DOCUMENTS_ROUTE_PATH,
  LMIV_ROUTE_PATH,
  SRM_TICKET_CREATE_ROUTE_PATH,
  SRM_TICKET_DETAILS_ROUTE_PATH,
  SRM_TICKET_OVERVIEW_ROUTE_PATH,
} from '@libs/shared/models';
import { DocumentOverviewComponent, DocumentsGuard } from './document';
import { LmivProductComponent } from './lmiv';
import { SrmCreateComponent, SrmDetailsComponent, SrmOverviewComponent } from './srm';

export const srmRoutes: Route[] = [
  {
    path: SRM_TICKET_OVERVIEW_ROUTE_PATH,
    component: SrmOverviewComponent,
  },
  {
    path: SRM_TICKET_CREATE_ROUTE_PATH,
    component: SrmCreateComponent,
  },
  {
    path: SRM_TICKET_DETAILS_ROUTE_PATH,
    component: SrmDetailsComponent,
  },
];

export const lmivRoutes: Route[] = [
  {
    path: LMIV_ROUTE_PATH,
    component: LmivProductComponent,
  },
];

export const documentRoutes: Route[] = [
  {
    path: DOCUMENTS_ROUTE_PATH,
    canActivate: [DocumentsGuard],
    component: DocumentOverviewComponent,
  },
];

export const serviceRoutes: Route[] = [
  ...srmRoutes,
  ...documentRoutes,
  ...lmivRoutes,
];

@NgModule({
  imports: [
    OverlayModule,
    RouterModule.forChild(serviceRoutes),
  ],
  exports: [],
})
export class ServiceRouteModule {
}
